// extracted by mini-css-extract-plugin
export var heroImage = "_dg-1";
export var modal = "_dg-0";